/* istanbul ignore file */
import { UpdatePageLayout } from 'framework/ui/layout';
import { UpdateForm } from 'framework/form';
import useEmployeeContractsService from 'domain/people/employee/contracts/shared/employeeContractsService';
import {
  useEmployeeContractId,
  useEmployeeContractUrl,
} from 'domain/people/employee/contracts/employeeContractRouting';
import EmployeeContractForm from 'domain/people/employee/contracts/createupdate/EmployeeContractForm';
import useContractsErrorMap from '../../errorHandlers';
import ContractNotStrictRulesHandler from '../../shared/ContractNotStictRulesHandler';
import { useShowContext } from 'framework/show';
import { useCacheService } from 'framework/cache';
import { EMPLOYEES_PATH } from 'domain/shared/employee';
import { FormFieldsData } from 'framework/form';
import useContractPositionSlotValidation from '../useContractPositionSlotValidation';

const UpdateEmployeeContract = () => {
  const { update, getById, getValidationSchema } = useEmployeeContractsService();
  const { getListUrl } = useEmployeeContractUrl();
  const id = useEmployeeContractId();
  const errorsMap = useContractsErrorMap();
  const { data } = useShowContext();
  const { invalidateCache } = useCacheService(EMPLOYEES_PATH);
  const employeeAlias = data.alias;
  const positionSlotId = (data?.getValueBySource?.('positionSlotId') as string | null) ?? data.positionSlotId ?? null;
  const { validateAndSubmit, validationWarningModal } = useContractPositionSlotValidation({
    employeeAlias,
    positionSlotId,
  });

  const handleSubmit = (contractId: StringOrNumber, values: FormFieldsData) =>
    validateAndSubmit(values, () => update(contractId, values));

  return (
    <UpdateForm
      submitFormFunc={handleSubmit}
      getDataFunc={getById}
      entityId={id}
      afterSubmit={{
        redirect: getListUrl(),
        message: 'You are awesome! The contract has been successfully saved.',
        execute: () => {
          invalidateCache();
        },
      }}
      getValidationSchemaFunc={getValidationSchema}
      errorsMap={errorsMap}
    >
      <ContractNotStrictRulesHandler errorMap={errorsMap} />
      <UpdatePageLayout title="Edit: Contract" titleVariant="h4">
        <EmployeeContractForm hasAnchorLinks employeeAlias={employeeAlias} />
      </UpdatePageLayout>
      {validationWarningModal}
    </UpdateForm>
  );
};

export default UpdateEmployeeContract;
